import { useState } from "react";
import { Link } from "react-router-dom";
import { Api } from "../../lib/api";
import { Button, TextField, Card } from "../../components/ui";
import "./auth.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await Api.forgotPassword(email);
      setSent(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="tg-auth-screen">
      <Card className="tg-auth-card">
        <h1 style={{ fontSize: 22 }}>Reset your password</h1>
        <p style={{ color: "var(--slate)", fontSize: 13.5, marginTop: 6, marginBottom: 20 }}>
          Enter your email and we&apos;ll send you a link to reset your password.
        </p>

        {sent ? (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <p style={{ fontSize: 14, color: "var(--success)" }}>
              ✓ If an account exists, a reset email has been sent.
            </p>
            <p style={{ fontSize: 13, color: "var(--slate)", marginTop: 10 }}>
              Check your inbox (and spam folder).
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="tg-auth-form">
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Button type="submit" fullWidth disabled={loading}>
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}

        <div style={{ marginTop: 18, textAlign: "center" }}>
          <Link to="/login" className="tg-link">← Back to login</Link>
        </div>
      </Card>
    </div>
  );
}
